import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { Action } from "redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"

import * as actions from "./actions"

import WorkspaceListPage from "./components/WorkspaceListPage"
import { IOldUIContext } from "../../global"

interface OldUIInit {
    start: (element: HTMLElement | undefined | null) => void
    refreshWorkspaces: () => Action
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const start = (element: HTMLElement | undefined | null): void => {
        if (!element) {
            throw new Error("Element should have value")
        }

        store.dispatch(actions.requestWorkspaces())

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <WorkspaceListPage />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const refreshWorkspaces = (): Action =>
        store.dispatch(actions.refreshWorkspaces())

    return {
        start,
        refreshWorkspaces,
    }
}

export default init
